module.exports = __webpack_public_path__ + "img/xz_certificate2.3e98ba7c.jpg";